module.exports = __webpack_public_path__ + "img/myBooking.bea2d15e.png";